module.exports = __webpack_public_path__ + "static/img/IMG_20170906_172520.69746e99.jpg";